import React from 'react'
import { createRegisterableComponent } from 'common/routing/page-definition'
import { TWStaticSubscribeCard } from 'component-library/cards/TWStaticSubscribeCard/TWStaticSubscribeCard'

export const StaticSubscribePromoCardRegistration = createRegisterableComponent(
    'tw-subscribe-promo-card',
    () => <TWStaticSubscribeCard />
)
